import { render, staticRenderFns } from "./form-buyout2.vue?vue&type=template&id=07ff9623&"
import script from "./form-buyout2.vue?vue&type=script&lang=js&"
export * from "./form-buyout2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {InputsSuggestions: require('/var/www/components/inputs/suggestions.vue').default,InputsInput: require('/var/www/components/inputs/input.vue').default,CheckboxGroup: require('/var/www/components/checkbox/checkbox-group.vue').default})
